var _defs, _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "mail_1_",
    width: 224.146,
    height: 214.4,
    "data-name": "mail (1)",
    viewBox: "0 0 224.146 214.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#ffc107}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    fill: "#ffd54f",
    d: "M224.915 20.706l-81.959 59.252-13.449 9.742a20.173 20.173 0 0 1-23.974 0l-13.449-9.742L10.027 20.8A24.228 24.228 0 0 1 29.81 10.668h175.419a24.364 24.364 0 0 1 19.686 10.038z",
    "data-name": "Path 7340",
    transform: "translate(-5.446 -10.668)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9686",
    "data-name": "Group 9686",
    transform: "translate(0 10.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    d: "M4.58 32.855L86.637 92.01 7.114 171.533A24.364 24.364 0 0 1 0 154.284v-107.2a24.072 24.072 0 0 1 4.58-14.229z",
    className: "cls-2",
    "data-name": "Path 7341",
    transform: "translate(0 -32.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    d: "M387.651 46.968v107.2a24.364 24.364 0 0 1-7.114 17.249l-79.523-79.522 81.959-59.253a24.225 24.225 0 0 1 4.678 14.326z",
    className: "cls-2",
    "data-name": "Path 7342",
    transform: "translate(-163.505 -32.642)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    fill: "#4f5373",
    d: "M215.709 313.552c-6.471 0-9.745-4.873-9.745-14.618a24.656 24.656 0 1 0-5.935 15.758 17.376 17.376 0 0 0 15.68 8.605c19.491 0 19.491-18.341 19.491-24.364a53.6 53.6 0 1 0-16.334 38.525 4.89 4.89 0 0 0-6.822-7.007 43.854 43.854 0 1 1 13.41-31.517c.001 10.924-2.454 14.618-9.745 14.618zm-34.109 0a14.618 14.618 0 1 1 14.618-14.618 14.618 14.618 0 0 1-14.618 14.618z",
    "data-name": "Path 7343",
    transform: "translate(-69.527 -138.133)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    fill: "#ffa000",
    d: "M145.969 162.348l-13.449 9.745a20.173 20.173 0 0 1-23.974 0L95.1 162.348l-79.526 79.523a24.362 24.362 0 0 0 17.25 7.114h24.607a63.278 63.278 0 0 1 126.195 0h24.617a24.364 24.364 0 0 0 17.25-7.114z",
    "data-name": "Path 7344",
    transform: "translate(-8.459 -93.057)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailLarge);
export default __webpack_public_path__ + "static/media/icon-mail--large.0c20b5cacbb1f3419699847f7f186806.svg";
export { ForwardRef as ReactComponent };